export default {"src":"/_next/static/media/mobileMenuOpen.e1911a98.svg","height":5,"width":18,"blurWidth":0,"blurHeight":0};